import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';
import React, { useState } from 'react';
import { TestId } from '@components/test-ids';
import { Theme } from '@theme/base';
import { TourPostTripReview } from '@model/tours';
import { SectionTitle } from '@components/common/section-title';
import { TourReview } from './TourReview';
import { useI18NextContext } from '@components/hooks';
import { Icon } from '@components/common/generic-icon';
import { Collapse } from '@mui/material';
import { ReadMore } from '@styles/common';

/* ***************** *
 *       Types       *
 * ***************** */
export interface TourReviewsGroupProps {
  theme?: Theme;
  testId?: string;
  reviews: Array<TourPostTripReview>;
  heading: string;
  initialNoOfReviews?: number;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const Container = styled.div({});

/* ****************************** *
 *    TourReviewGroupComponent    *
 * ****************************** */

export const TourReviewGroupComponent = ({
  reviews,
  heading,
  testId,
  initialNoOfReviews = 3
}: TourReviewsGroupProps) => {
  const t: any = useI18NextContext();

  if (!reviews || !reviews.length) {
    return null;
  }

  /* *** STATE *** */
  const [expanded, setExpanded] = useState<boolean>(false);

  /* *** RENDERERS *** */
  const renderTourReviews = (renderMoreReviews?: boolean) =>
    reviews.map(
      ({ name, date, review }: TourPostTripReview, index: number) =>
        ((!renderMoreReviews && index < initialNoOfReviews!) ||
          (renderMoreReviews && index >= initialNoOfReviews!)) && (
          <TourReview key={`${name}-${date}`} name={name} date={date} review={review} />
        )
    );

  return (
    <Container data-testid={testId || TestId.tourReview.group}>
      <SectionTitle heading={heading} />
      <div>{renderTourReviews()}</div>
      {reviews.length > initialNoOfReviews! && (
        <>
          <Collapse in={expanded}>{renderTourReviews(true)}</Collapse>
          <ReadMore onClick={() => setExpanded(!expanded)}>
            <span>{t(expanded ? 'common__description--show-less' : 'common__description--show-more')}</span>
            <Icon name={expanded ? 'mhi-chevron-up' : 'mhi-chevron-down'} />
          </ReadMore>
        </>
      )}
    </Container>
  );
};

export const TourReviewGroup = withTheme(TourReviewGroupComponent);
